import http from '@/utils/request';

// 客户信息列表
export const getCustomerList = (data = {}) => {
  const url = '/account/customer/bopList';
  return http.post({
    url,
    data,
  });
};

//  客户详情-基本信息
export const getCustomerBaseinfo = (data = {}) => {
  const url = '/account/customer/baseinfo';
  return http.post({
    url,
    data,
  });
};

// 客户详情-联系人信息
export const getCustomerContact = (data = {}) => {
  const url = '/account/customer/contact';
  return http.post({
    url,
    data,
  });
};

// 客户详情-银行卡信息
export const getCustomerBankcard = (data = {}) => {
  const url = '/account/customer/bankcard';
  return http.post({
    url,
    data,
  });
};

// 客户详情-证照信息
export const getCustomerCredentials = (data = {}) => {
  const url = '/account/customer/credentials';
  return http.post({
    url,
    data,
  });
};

// 客户详情-服务商添加银行卡
export const addServiceBankcard = (data = {}) => {
  const url = '/account/customer/service/bankcard';
  return http.post({
    url,
    data,
  });
};
